export default __webpack_public_path__ + "static/media/YAS0070.34I-27542_-16529_15.5550028a.jpg";